export const MoneyfarmTheme = {
    id: 'mf',
    palette: {
        white: {
            dark: '#FBFAF9',
            main: '#ffffff',
        },
        midnight: {
            main: '#262F3A',
        },
        cyan: {
            dark: '#007ECC',
            main: '#008EE5',
            light: '#85C6FF',
            lighter: '#F2FAFF',
        },
        yellow: {
            dark: '#EDAE0C',
            main: '#FFBC2E',
            light: '#FFD67D',
            lighter: '#fff8e8',
        },
        magenta: {
            main: '#FF4791',
            light: '#FF87B7',
        },
        neutral: {
            darker: '#51677D',
            dark: '#637D96',
            main: '#99ABBD',
            light: '#CAD1D9',
            lighter: '#F7F8F9',
        },
        positive: {
            main: '#4CA752',
            light: '#77C97C',
            lighter: '#F0FCF1',
        },
        negative: {
            main: '#EB6767',
            light: '#FA9191',
            lighter: '#FFF5F5',
        },
    },
    tokens: {
        space: {
            primary: {
                regular: '#FFFFFF',
            },
            secondary: {
                regular: '#FAFBFD',
                gradient100: '#FAFBFD',
                gradient0: '#FFFFFF',
            },
            tertiary: {
                regular: '#F7F4EF',
                gradient100: '#FAF8F4',
                gradient0: '#FFFFFF',
            },
            surface: {
                regular: '#FFFFFF',
            },
        },
        accent: {
            token: {
                primary: {
                    strong: '#007ECC',
                    regular: '#008EE5',
                    light: '#85C6FF',
                },
                secondary: {
                    strong: '#000000',
                    regular: '#26364F',
                    light: '#99ABBD',
                },
            },
            onToken: {
                primary: {
                    strong: '#FFFFFF',
                    regular: '#FFFFFF',
                    light: '#FFFFFF',
                },
                secondary: {
                    strong: '#FFFFFF',
                    regular: '#FFFFFF',
                    light: '#FFFFFF',
                },
            },
            base: {
                primary: {
                    strong: '#000000',
                    regular: '#262F3A',
                    light: '#99ABBD',
                },
                secondary: {
                    strong: '#007ECC',
                    regular: '#008EE5',
                    light: '#85C6FF',
                },
            },
        },
        interface: {
            shadow: {
                strong: '#99ABBD66',
                regular: '#99ABBD4D',
                light: '#99ACBD33',
            },
            neutral: {
                strong: '#637D96',
                regular: '#99ABBD',
                light: '#CAD1D9',
                lightest: '#F7F8F9',
            },
            feedback: {
                negative: {
                    strong: '#D14747',
                    regular: '#EB6767',
                    light: '#FA9191',
                    lightest: '#FFF5F5',
                },
                positive: {
                    strong: '#4CA752',
                    regular: '#4CA752',
                    light: '#77C97C',
                    lightest: '#F0FCF1',
                },
                warning: {
                    strong: '#EDAE0C',
                    regular: '#FFBC2E',
                    light: '#FFD67D',
                    lightest: '#FFF8E5',
                },
                info: {
                    strong: '#007ECC',
                    regular: '#008EE5',
                    light: '#85C6FF',
                    lightest: '#F2FAFF',
                },
            },
            onFeedback: {
                strong: '#FFFFFF',
                regular: '#FFFFFF',
                light: '#26364F',
                lightest: '#26364F',
            },
        },
        feature: {
            esg: {
                strong: '#4CA752',
                regular: '#77C97C',
                light: '#F0FCF1',
            },
        },
        chart: {
            primary: {
                main: '#008EE5',
                child1: '#99D2F5',
                child2: '#E6F4FC',
            },
            secondary: {
                main: '#EDAE0C',
                child1: '#FFBC2E',
                child2: '#FFD67D',
            },
            tertiary: {
                main: '#FF4791',
                child1: '#FF87B7',
                child2: '#FFCCE0',
            },
        },
        allocation: {
            bond: {
                main: '#99ABBD',
                child01: '#637D96',
                child02: '#99ABBD',
                child03: '#CAD1D9',
                child04: '#FFBC2E',
                child05: '#FFD67D',
            },
            equity: {
                main: '#FF4791',
                child01: '#FF4791',
                child02: '#FF87B7',
            },
            other: {
                main: '#008EE5',
                child01: '#007ECC',
                child02: '#008EE5',
            },
        },
        text: {
            title: {
                regular: '#262F3A',
                light: '#51677D',
                lighter: '#99ABBD',
                reversed: '#FFFFFF',
            },
            paragraph: {
                regular: '#262F3A',
                light: '#51677D',
                lighter: '#99ABBD',
                reversed: '#FFFFFF',
            },
            label: {
                regular: '#262F3A',
                light: '#51677D',
                lighter: '#99ABBD',
                reversed: '#FFFFFF',
                negative: '#EB6767',
                positive: '#4CA752',
                warning: '#EDAE0C',
                info: '#008EE5',
                primary: '#008EE5',
                secondary: '#262F3A',
                tertiary: '#FF4791',
            },
        },
    },
    typography: {
        font: {
            sizes: {
                small: 13,
                normal: 16,
                smedium: 18,
                medium: 21,
                big: 24,
                bigger: 38,
            },
            weight: {
                normal: 400,
                semibold: 600,
            },
            family: {
                title: 'Montserrat, "Open Sans", Helvetica, Arial;',
                text: '"Open Sans", Helvetica, Arial;',
            },
            style: ['normal'],
        },
    },
};
//# sourceMappingURL=Moneyfarm.js.map